export default __webpack_public_path__ + "static/media/Address.0a519185.png";